{
   "error_key_unauthorized_or_no_partner_associated": "Unauthorized or no partner associated.",
   "error_key_only_the_proposal_manager_can_execute_this_action": "Only the proposal manager can execute this action.",
   "error_key_domain_not_found": "Domain not found.",
   "error_key_domain_status_not_found": "Status not found.",
   "error_key_domain_visibility_not_found": "Visibility not found.",
   "error_key_domain_geographicalCoverage_not_found": "Geographical coverage not found.",
   "error_key_domain_project_already_associated_partner": "Project already associated with this partner.",
   "error_key_domain_partner_not_associated_person": "Partner not associated with this person.",
   "error_key_domain_project_not_associated_partner": "Project not associated with this partner.",
   "error_key_domain_person_email_already_taken": "Person email already taken.",
   "error_key_partner_shortname_already_taken": "Shortname already taken.",
   "error_key_partner_subpartner_id_not_found": "Subpartner ID not found.",
   "error_key_partner_subpartner_type_cannot_be_regular": "Subpartner type cannot be regular.",
   "error_key_partner_subpartner_associated_to_another_parent": "Subpartner associated to another parent.",
   "error_key_country_type_invalid": "Country type invalid.",
   "error_key_partner_subpartner_not_associated_subpartner_to_project": "Subpartner not associated with the project.",
   "error_key_project_status_cannot_be_changed": "Project status cannot be changed.",
   "error_key_id_not_valid_null": "Id not valid or null.",
   "error_key_email_invalid_format": "Email invalid format.",
   "error_key_invalid_status_change": "Invalid status change.",
   "error_key_grant_change_on_running_projects_not_valid": "Grant change on running projects not valid.",
   "error_key_pno_country_responsible_not_found": "PNO country responsible not found.",
   "error_key_not_allowed_insufficient_permissions": "Insufficiente permissions.",
   "error_key_network": "Connection error. Please check your internet connection.",
   "error_key_partner_legalname_already_taken": "This partner legalname already exist.",
   "error_key_conflict_associated_organisation_already_exists": "The associated organisation already exists.",
   "error_key_reporting_period_invalid": "Invalid reporting period.",
   "error_key_reporting_period_invalid_range": "Invalid reporting period range.",
   "error_key_reporting_period_overlap": "Reporting period overlap.",
   "error_key_no_reporting_period_to_delete": "No reporting period to delete.",
   "error_key_project_duration_required": "Project duration is required.",
   "error_key_reporting_period_exceeds_project_duration": "Reporting period exceeds project duration.",
   "error_key_legalname_empty_or_whitespace": "Invalid legalname.",
   "error_key_domain_partner_already_associated_person": "The domain partner is already associated with this person.",
   "error_key_mail_list_not_created": "Mailing list not created.",
   "error_key_mail_list.not_added_person_to_mailing_list": "Person not added to mailing list.",
   "error_key_mail_list_not_removed_person_from_mailing_list": "Person not removed from mailing list.",
   "error_key_mail_list_name_already_used": "Mailing list name already used.",
   "error_key_mail_list_not_found_mailing_list": "Mailing list not found.",
   "error_key_mail_list_already_present_person_in_mailing_list": "Person already present in mailing list.",
   "error_key_mail_list_not_present_person_in_mailing_list": "Person not present in mailing list.",
   "error_key_mail_list_not_editable_status_of_mailing_list": "Status of mailing list not editable.",
   "error_key_mail_list_not_editable_name_of_mailing_list": "Name of mailing list not editable.",
   "error_key_todos_unauthorized_or_no_partner_associated": "Unauthorized or no partner associated.",
   "error_key_todos_unauthorized_you_are_not_the_pm": "You are not the project manager.",
   "error_key_todos_todo_not_found": "Todo not found.",
   "error_key_todos_todo_deadline_must_be_in_the_future": "Todo deadline must be in the future.",
   "error_key_quicklink_already_existing":" Quicklink already existing."
}

